export const appConfig = {...appConfigProxy(), ...staticConfig()};

function staticConfig() {
  return {
    authWellKnownPath: '/.well-known/openid-configuration',
    jwtIoUrl: 'https://jwt.io',
    iuaActorsTransactionsUrl: 'https://profiles.ihe.net/ITI/IUA/index.html#341-iua-actors-transactions-and-content-modules',
    iuaITI71Url: 'https://profiles.ihe.net/ITI/IUA/index.html#371-get-access-token-iti-71',
    iuaAuthCodeFlowUrl: 'https://profiles.ihe.net/ITI/IUA/index.html#3714122-authorization-code-grant-type',    
    iuaClientCredFlowUrl: 'https://profiles.ihe.net/ITI/IUA/index.html#3714121-client-credential-grant-type',
    iuaITI103Url: 'https://profiles.ihe.net/ITI/IUA/index.html#3103-get-authorization-server-metadata-iti-103',
    // resourceServer: {
    //   // testEndpoint1: 'http://localhost:7090/iua-resource/psca-status',
    //   testEndpoint1: 'https://ps-swagger-api.apibox.ca/cafex/Bundle/1', // CAFEX-3
    //   testEndpoint2: 'https://ps-swagger-api.apibox.ca/mhd/DocumentReference?patient.identifier=1234-56789&status=current' // ITI-67
    // }
  }
}

function appConfigEmpty() {
  return {
    wellKnownUri: 'http://localhost:9080/auth/realms/ps-ca-api-realm/.well-known/openid-configuration',
    authorizeUri: '',
    tokenUri: '',
    redirectUri: 'http://localhost:3000/authorize',
    appApi: {},   
  }
}

function appConfigLocal() {
  return {
    wellKnownUri: 'http://localhost:9080/auth/realms/ps-ca-api-realm/.well-known/openid-configuration',
    // authorizeUri: '',
    // tokenUri: '',
    authorizeUri: 'http://localhost:9080/auth/realms/ps-ca-api-realm/protocol/openid-connect/auth',
    tokenUri: 'http://localhost:9080/auth/realms/ps-ca-api-realm/protocol/openid-connect/token',
    redirectUri: 'http://localhost:3000/authorize',
    authMetadataUri: 'http://localhost:9080/auth/realms/ps-ca-api-realm/.well-known/openid-configuration',
    clientId: 'ps-ca-api-standard-PKCE-client',
    clientSecret: 'JwXYWm1YDlKMT8JiAJnNRqP8BdBr8yPe',
    confidentialClientId: 'ps-ca-api-standard-PKCE-client',
    confidentialClientSecret: 'JwXYWm1YDlKMT8JiAJnNRqP8BdBr8yPe',
    publicClientId: 'ps-ca-api-standard-PKCE-public-client',
    serviceClientId: 'ps-ca-api-rest-client',
    serviceClientSecret: 'SmtNkpB4rHd7VOr9qm0MbH5zMIU2tSC3',
    // scopes: 'CAFEX-3',
    appApi: {
      tokenEndpoint: 'http://localhost:5000/auth/token'
    }
  }
}

function appConfigDev() {
  return {
    wellKnownUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/.well-known/openid-configuration',
    authorizeUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/protocol/openid-connect/auth',
    tokenUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/protocol/openid-connect/token',
    // redirectUri: 'http://localhost:3000/authorize',
    redirectUri: 'https://iua.apibox.ca/authorize',
    authMetadataUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/.well-known/openid-configuration',
    clientId: 'ps-ca-standard-PKCE-client',
    clientSecret: 'a1f80369-9fc9-429e-bfad-cb7bc0ea13b8',
    publicClientId: 'ps-ca-standard-PKCE-public-client',
    confidentialClientId: 'ps-ca-standard-PKCE-client',
    confidentialClientSecret: 'a1f80369-9fc9-429e-bfad-cb7bc0ea13b8',
    serviceClientId: 'ps-ca-rest-client',
    serviceClientSecret: '0e156b24-2d9c-4271-aab1-38ed528da64d',
    appApi: {
      tokenEndpoint: 'https://iua-api.apibox.ca/auth/token'
    }
  }
}

function appConfigDevAWS() {
  return {
    wellKnownUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/.well-known/openid-configuration',
    authorizeUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/protocol/openid-connect/auth',
    tokenUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/protocol/openid-connect/token',
    // redirectUri: 'http://localhost:3000/authorize',
    redirectUri: 'https://iua.apibox.ca/authorize',
    authMetadataUri: 'https://dev-keycloak.apibox.ca/auth/realms/ps-ca-realm/.well-known/openid-configuration',
    clientId: 'ps-ca-standard-PKCE-client',
    clientSecret: '',
    publicClientId: 'ps-ca-standard-PKCE-public-client',
    confidentialClientId: 'ps-ca-standard-PKCE-client',
    confidentialClientSecret: '',
    serviceClientId: 'ps-ca-rest-client',
    serviceClientSecret: '',
    appApi: {
      tokenEndpoint: 'https://iua-api.apibox.ca/auth/token'
    }
  }
}

function appConfigProxy() {
  return {
    wellKnownUri: 'https://pancanadianio.ca:10100/auth/realms/ps-ca/.well-known/openid-configuration',
    authorizeUri: 'https://pancanadianio.ca:10100/auth/realms/ps-ca/protocol/openid-connect/auth',
    tokenUri: 'https://pancanadianio.ca:10100/auth/realms/ps-ca/protocol/openid-connect/token',
    // redirectUri: 'http://localhost:3000/authorize',
    redirectUri: 'https://iua.apibox.ca/authorize',
    authMetadataUri: 'https://pancanadianio.ca:10100/auth/realms/ps-ca/.well-known/openid-configuration',
    clientId: 'ps-ca-standard-PKCE-client',
    clientSecret: '',
    publicClientId: 'ps-ca-standard-PKCE-public-client',
    confidentialClientId: 'ps-ca-standard-PKCE-client',
    confidentialClientSecret: '',
    serviceClientId: 'ps-ca-rest-client',
    serviceClientSecret: '',
    appApi: {
      tokenEndpoint: 'https://pancanadianio.ca:10007/auth/token'
      // tokenEndpoint: 'https://iua-api.apibox.ca/auth/token'
      // tokenEndpoint: 'http://localhost:5000/auth/token'
    }
  }
}

function appConfigCognito() {
  return {
    wellKnownUri: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_wGrkZH968/.well-known/openid-configuration',
    authorizeUri: 'https://iua-dev.auth.ca-central-1.amazoncognito.com/oauth2/authorize',
    tokenUri: 'https://iua-dev.auth.ca-central-1.amazoncognito.com/oauth2/token',
    redirectUri: 'http://localhost:3000/authorize',
    // redirectUri: 'https://iua.apibox.ca/authorize',
    authMetadataUri: 'https://cognito-idp.ca-central-1.amazonaws.com/ca-central-1_wGrkZH968/.well-known/openid-configuration',
    clientId: '12jlt8jnl4ionfprcnn6a6kuon',
    clientSecret: '15slhnrhs39h411f2t30jvtls1gkn5rront9noqkkaasc7nhdihi',
    publicClientId: '5g04mn2d6eleip0aoh2fr5595i',
    confidentialClientId: '12jlt8jnl4ionfprcnn6a6kuon',
    confidentialClientSecret: '15slhnrhs39h411f2t30jvtls1gkn5rront9noqkkaasc7nhdihi',
    serviceClientId: '71q9vdtfuj7afnmvk84dcj0q6n',
    serviceClientSecret: '11khiqej7mea7v2pbk7uh36gubn1e07or2rhnngk24fa71m38ura',
    appApi: {
      // tokenEndpoint: 'https://iua-api.apibox.ca/auth/token'
      tokenEndpoint: 'http://localhost:5000/auth/token'
    }
  }
}
